<template>
  <div class="new-condition">
    <zg-tooltip
      v-if="type === 'new'"
      placement="bottom"
      class="label"
      :content="'数据更新时间: ' + dataUpdateTime + ' 该属性数据每日凌晨更新'"
    >
      {{ label }}<span class="prop-symbol">{{ propSymbol }}</span>
    </zg-tooltip>
    <span v-else class="label">{{ label }}</span>
    <zg-selector
      class="operate-select mr5"
      :store="operatorList"
      :width="90"
      v-model="operator"
      keyField="value"
      label-field="name"
      @change="onChangeOperator"
    ></zg-selector>

    <zg-input
      v-if="operator.value === 'relative'"
      :width="52"
      v-model="propValue"
      class="number-value"
      placeholder="相对时间"
    ></zg-input>
    <template v-if="operator.value === 'relative'">
      <span class="ml10">天</span>
      <span class="ml10" v-if="type === 'active' && propValue !== '0'">
        <c-checkbox v-model="todayDisable">不包含今天</c-checkbox>
      </span>
    </template>
    <el-date-picker
      v-else
      v-model="propValue"
      type="daterange"
      :editable="false"
      :clearable="false"
      range-separator="~"
      :picker-options="shortcuts"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
    >
    </el-date-picker>
    <span v-if="showSourceSelect">
      <zg-selector
        class="ml10"
        :store="sourceStore"
        :width="120"
        v-model="sourceApp"
        keyField="id"
        label-field="appName"
      ></zg-selector>
    </span>
    <div style="display: none">{{ output }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { util } from '../../utils'
import { actions } from '../../store/constants'
export default {
  name: 'newCondition',
  props: {
    value: null,
    type: {
      type: String,
      validator(value) {
        return ['new', 'active'].includes(value)
      }
    }
  },
  data() {
    let data = {
      operator: { value: 'relative' },
      propValue: '30',
      todayDisable: false,
      shortcuts: {
        disabledDate(time) {
          let end = new Date().setHours(0, 0, 0, 0)
          let current = time.getTime()
          return current > end
        }
      },
      sourceApp: {
        id: -1,
        appName: '任意应用'
      },
      propSymbol: '*',
      dataUpdateTime: null
    }
    if (this.value) {
      data.operator = {
        value: this.value.runPeriod.operator
      }
      switch (this.value.runPeriod.operator) {
        case 'relative':
          data.propValue = this.value.runPeriod.values[0]
          data.todayDisable = this.value.runPeriod.values[1] === '1'
          break
        case 'absolute':
          data.propValue = [
            new Date(this.value.runPeriod.values[0]),
            new Date(this.value.runPeriod.values[1])
          ]
          break
      }
      if (this.value.attrs.length) {
        this.value.attrs.forEach(item => {
          data.sourceApp = {
            id: item.params[0],
            appName: item.params[1]
          }
        })
      }
    }
    return data
  },
  computed: {
    ...mapState({
      operatorList(state) {
        return state.common.dateOperate
      },
      currentApp(state) {
        return state.app.currentApp
      },
      sourceStore(state) {
        let sourceArr = state.app.virtualAppSource
        let list = [
          {
            id: -1,
            appName: '任意应用'
          }
        ].concat(sourceArr)
        return list
      }
    }),
    showSourceSelect() {
      return (
        this.type === 'active' && this.currentApp.appType && this.isVirtualApp
      )
    },
    label() {
      return this.type === 'new' ? '新增于' : '活跃于'
    },
    output() {
      let output = {
        attrs: [],
        eventId: this.type === 'new' ? '-3' : '-4',
        runPeriod: {
          operator: this.operator.value,
          values: this.getRunPeriodValues()
        },
        runTimes: {
          operator: '>=',
          values: ['1']
        }
      }
      if (this.showSourceSelect) {
        output.attrs = [
          {
            attrId: 0,
            attrName: 'env_attr3',
            operator: 'end with',
            params: [this.sourceApp.id, this.sourceApp.appName],
            attrType: 'cont-string',
            category: 'fixed'
          }
        ]
      }
      this.$emit('input', output)
      this.$emit('change', output)
      return output
    }
  },
  watch: {
    propValue () {
      if (this.propValue === '0') {
        this.todayDisable = false
      }
    }
  },
  created() {
    if (this.type === 'new') {
      this.$store.dispatch(actions.common.appUpdateTime).then(res => {
        this.dataUpdateTime = res.times.update_time
      })
    }
    if (this.showSourceSelect) {
      this.$store.dispatch(actions.app.queryVirtualAppSourceApps)
    }
  },
  methods: {
    getRunPeriodValues() {
      let values = []
      switch (this.operator.value) {
        case 'relative':
          values.push(this.propValue)
          if (this.currentApp.realTime) {
            values.push(this.todayDisable ? '1' : '0')
          } else {
            values.push('1')
          }
          break
        case 'absolute':
          values = this.propValue.map(time => util.dateFormat(time))
          break
        default:
          values = []
      }
      return values
    },
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      if (
        ['join_time', 'relative'].includes(this.operator.value) &&
        (util.isEmpty(this.propValue) || isNaN(this.propValue))
      ) {
        result.valid = false
        result.errorMsg = '属性值错误或为空'
      }
      return result
    },
    onChangeOperator() {
      if (this.operator.value === 'absolute') {
        let oneDate = 24 * 60 * 60 * 1000
        let end = new Date(new Date().getTime() - oneDate)
        let start = new Date(end - oneDate * 6)
        this.propValue = [start, end]
      } else {
        this.propValue = '30'
      }
    }
  }
}
</script>

<style lang="sass">
.new-condition
  display: inline-block
  .mr5
    margin-right: 5px
  .ml10
    margin-left: 10px
  >span
    display: inline-block
  >span.label
    width: 60px
    text-align: right
    margin-right: 5px
    font-weight: bold
    .prop-symbol
      font-size: 12px
      margin-left: 2px
      font-weight: normal
  .c-input.number-value
    vertical-align: top
  .el-date-editor--daterange.el-input
    width: 236px
    vertical-align: top
    .el-input__inner
      height: 32px
</style>
